module.exports = __webpack_public_path__ + "img/qft-line-short.b94e2ccc.svg";